import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Button
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ChatIcon from '@mui/icons-material/Chat';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PaymentIcon from '@mui/icons-material/Payment';

const labels = {
  si: {
    title: 'පාරිභෝගිකයින්ට උපදෙස්',
    intro: 'මෙම වෙබ්සයිට් මගින් ඔබට ඔබගේ අනාගත මනමාලිගෙන් හෝ මනමාලයා සොයා ගැනීමට සහාය වන්නෙමු.',
    adviceTitle: 'පාරිභෝගිකයින්ට උපදෙස්',
    adviceP1: 'අපගේ වෙබ් අඩවියෙන්, ඔබට ඔබේ අභිමතය පරිදි ඔබේ පරමාදර්ශී මනාලිය හෝ මනාලයා සොයා ගත හැකිය. එක් එක් පැතිකඩ සඳහා "වැඩි විස්තර" කොටස යටතේ ඔවුන්ගේ විස්තර ලබා ගත හැකිය.',
    adviceP2: 'සම්බන්ධතා තොරතුරු ලබා ගැනීම සඳහා, ඔබ වෙබ් අඩවියේ ලියාපදිංචි විය යුතුය. පිවිසීමෙන් පසු, ඔබ ගෙවීමක් කළ යුතුය. අන්තර්ජාල බැංකුකරණය හරහා ගෙවීම් කළ හැකිය, නැතහොත් අපගේ උඩුගත කිරීමේ පෝරමය හරහා ඔබට බැංකු ස්ලිප්පතක් උඩුගත කළ හැකිය. ඔබගේ ලියාපදිංචිය තහවුරු වූ පසු, ඔබට ඔබ කැමති මනාලියගේ හෝ මනාලයාගේ සම්බන්ධතා තොරතුරු ලබා ගත හැක.',
    stepsTitle: 'මෙහි පියවර අනුගමනය කළ යුතුය:',
    registration: 'ලියාපදිංචිය සිදු කරන්න – ඔබ පළමුව වෙබ්සයිට් එකේ ලියාපදිංචිය කළ යුතුය.',
    requiredDetailsTitle: 'ලියාපදිංචිය සඳහා අවශ්‍ය විස්තර:',
    requiredDetails: [
      'ඔබගේ නම',
      'විද්‍යුත් තැපැල් ලිපිනය (E-mail)',
      'ජාතික හැඳුනුම්පත් අංකය',
      'මුරපදය'
    ],
    instructions: [
      'සියලුම විස්තර නිවැරදිව ලබාදිය යුතුය.',
      'ලියාපදිංචියෙන් පසු, ඔබේ පුද්ගලික විස්තර ඇතුළත් කරන්න.',
      'ඔබගේ විස්තර ඇතුළත් කිරීමෙන් පසු, එය සුරකින්න.',
      'ලියාපදිංචිය නොමැතිව, ඔබට සාමාජිකයින් පිළිබඳ වැඩිදුර විස්තර බැලිය නොහැක.',
      'සාමාජිකයින්ගේ වැඩිදුර විස්තර බලන්නට ඔබට ගෙවීමක් සිදු කළ යුතුය.',
      'ගෙවීම් සම්පූර්ණ වූවත්, ඔබ කැමති පුද්ගලයෙකුගේ සම්බන්ධතා විස්තර ලබා ගැනීමට ඔවුන්ගේ අනුමැතිය අවශ්‍ය වේ.'
    ],
    chatTitle: 'චැට් පහසුකම පිළිබඳව:',
    chatInfo: 'ඔබට අනෙක් පුද්ගලයා සමඟ චැට් කිරීමට නම්, ඔබ දෙදෙනාම එකිනෙකා ප්‍රියතම ලැයිස්තුවට එකතු කර තිබිය යුතුය. එනම්, ඔබ ඔවුන්ව ප්‍රියතමයෙකු ලෙස සලකුණු කළ යුතු අතර, ඔවුන්ද ඔබව ප්‍රියතමයෙකු ලෙස සලකුණු කර තිබිය යුතුය. මෙය සම්පූර්ණ වූ පසු පමණක් චැට් පහසුකම ලබා ගත හැක.',
    privacyTitle: 'රහස්‍යතා අනතුරු ඇඟවීම:',
    privacyInfo: 'කරුණාකර ඔබේ පෞද්ගලික තොරතුරු අන් අයට බෙදා හරින විට ප්‍රවේශම් වන්න. ඔබේ ජාතික හැඳුනුම්පත් අංකය, බැංකු විස්තර, හෝ වෙනත් සංවේදී තොරතුරු අනවශ්‍ය ලෙස බෙදා නොගන්න. ඔබේ ආරක්ෂාව සහතික කර ගැනීම ඔබේ වගකීමයි.',
    conclusion: 'මෙම ක්‍රියාවලිය අනුගමනය කර ඔබේ අනාගත සහකරු හෝ සහකාරිය සොයා ගන්න! 💍'
  },
  en: {
    title: 'Advice to Customers',
    intro: 'This website helps you find your future bride or groom.',
    adviceTitle: 'General Advice',
    adviceP1: 'From our website, you can search for your ideal bride or groom according to your preferences. Their details are available under the "more details" section for each profile.',
    adviceP2: 'To access contact details, you need to register on the website. After logging in, you will be required to make a payment. Payments can be done via online banking, or you can upload a bank slip through our upload form. Once your registration is confirmed, you can access the contact details of your preferred bride or groom.',
    stepsTitle: 'Follow these steps:',
    registration: 'Register – You must first register on the website.',
    requiredDetailsTitle: 'Required details for registration:',
    requiredDetails: [
      'Your Name',
      'Email Address',
      'National Identity Card Number',
      'Password'
    ],
    instructions: [
      'All details must be provided accurately.',
      'After registration, enter your personal details.',
      'After entering your details, save them.',
      'Without registration, you cannot view detailed member profiles.',
      'To view detailed member profiles, you must make a payment.',
      'Even after payment, you need the other person\'s approval to access their contact details.'
    ],
    chatTitle: 'About Chat Feature:',
    chatInfo: 'To chat with another person, both of you must add each other to your favorites list. This means you must mark them as a favorite, and they must also mark you as a favorite. Only after this is complete can you access the chat feature.',
    privacyTitle: 'Privacy Warning:',
    privacyInfo: 'Please be cautious when sharing your personal information with others. Do not unnecessarily share your National Identity Card number, bank details, or other sensitive information. Ensuring your security is your responsibility.',
    conclusion: 'Follow this process to find your future partner! 💍'
  }
};

const InforPage = ({ language = 'si' }) => {
  const t = labels[language] ?? labels.si;

  return (
    <Box sx={{ position: 'relative', minHeight: '100vh', overflowX: 'hidden' }}>
      {/* Blurred Background */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: 'url(../../images/bg-informationPage.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          filter: 'blur(8px)',
          zIndex: 1,
        }}
      />

      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 2,
        }}
      />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 3, py: { xs: 12, md: 16 } }}>
        <Paper elevation={3} sx={{
          p: { xs: 3, md: 5 },
          borderRadius: 4,
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)'
        }}>

          <Box sx={{ textAlign: 'center', mb: 5 }}>
            <Typography variant="h3" component="h1" gutterBottom sx={{
              fontWeight: 700,
              color: '#1a237e',
              fontSize: { xs: '2rem', md: '3rem' }
            }}>
              {t.title}
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ maxWidth: '800px', mx: 'auto' }}>
              {t.intro}
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {/* Advice Section */}
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 3, height: '100%', backgroundColor: '#f5f5f5', borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <InfoOutlinedIcon color="primary" sx={{ mr: 1, fontSize: 30 }} />
                  <Typography variant="h5" color="primary" fontWeight="bold">
                    {t.adviceTitle}
                  </Typography>
                </Box>
                <Typography variant="body1" paragraph lineHeight={1.8}>
                  {t.adviceP1}
                </Typography>
                <Typography variant="body1" lineHeight={1.8}>
                  {t.adviceP2}
                </Typography>
              </Box>
            </Grid>

            {/* Registration & Steps */}
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 3, height: '100%', border: '1px solid #e0e0e0', borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <GroupAddIcon color="secondary" sx={{ mr: 1, fontSize: 30 }} />
                  <Typography variant="h5" color="secondary" fontWeight="bold">
                    {t.stepsTitle}
                  </Typography>
                </Box>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  {t.registration}
                </Typography>

                <Typography variant="subtitle2" sx={{ mt: 2, color: 'text.secondary' }}>
                  {t.requiredDetailsTitle}
                </Typography>
                <List dense>
                  {t.requiredDetails.map((detail, index) => (
                    <ListItem key={index}>
                      <ListItemIcon sx={{ minWidth: 32 }}>
                        <CheckCircleOutlineIcon color="success" fontSize="small" />
                      </ListItemIcon>
                      <ListItemText primary={detail} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Grid>

            {/* Instructions */}
            <Grid item xs={12}>
              <Box sx={{ p: 3, backgroundColor: '#e3f2fd', borderRadius: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <PaymentIcon color="info" sx={{ mr: 1, fontSize: 30 }} />
                  <Typography variant="h6" color="info.main" fontWeight="bold">
                    Payment & Access
                  </Typography>
                </Box>
                <List>
                  {t.instructions.map((instruction, index) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <Box sx={{
                          width: 8,
                          height: 8,
                          bgcolor: 'info.main',
                          borderRadius: '50%'
                        }} />
                      </ListItemIcon>
                      <ListItemText primary={instruction} />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Grid>

            {/* Chat Feature */}
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 3, height: '100%', border: '1px solid #bbdefb', borderRadius: 2, backgroundColor: '#fff' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <ChatIcon color="action" sx={{ mr: 1, fontSize: 30 }} />
                  <Typography variant="h5" color="text.primary" fontWeight="bold">
                    {t.chatTitle}
                  </Typography>
                </Box>
                <Typography variant="body1" lineHeight={1.7}>
                  {t.chatInfo}
                </Typography>
              </Box>
            </Grid>

            {/* Privacy Warning */}
            <Grid item xs={12} md={6}>
              <Box sx={{ p: 3, height: '100%', backgroundColor: '#fff3e0', borderRadius: 2, border: '1px solid #ffe0b2' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <WarningAmberIcon color="warning" sx={{ mr: 1, fontSize: 30 }} />
                  <Typography variant="h5" color="warning.main" fontWeight="bold">
                    {t.privacyTitle}
                  </Typography>
                </Box>
                <Typography variant="body1" color="text.secondary" lineHeight={1.7}>
                  {t.privacyInfo}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Box sx={{ mt: 6, textAlign: 'center' }}>
            <Typography variant="h5" color="primary" sx={{ mb: 3, fontStyle: 'italic' }}>
              {t.conclusion}
            </Typography>

            <Typography variant="subtitle1" gutterBottom>
              Contact Us On:
            </Typography>
            <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center' }}>
              {/* WhatsApp */}
              <a
                href="https://wa.me/+94787738966"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  bgcolor: '#25D366',
                  color: 'white',
                  px: 2,
                  py: 1,
                  borderRadius: 2,
                  boxShadow: 2,
                  '&:hover': { opacity: 0.9 }
                }}>
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                    alt="WhatsApp"
                    style={{ width: 24, height: 24 }}
                  />
                  <Typography fontWeight="bold">WhatsApp</Typography>
                </Box>
              </a>

              {/* Messenger */}
              <a
                href="https://www.facebook.com/share/16AGRMhGVQ/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  bgcolor: '#0084FF',
                  color: 'white',
                  px: 2,
                  py: 1,
                  borderRadius: 2,
                  boxShadow: 2,
                  '&:hover': { opacity: 0.9 }
                }}>
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/b/be/Facebook_Messenger_logo_2020.svg"
                    alt="Messenger"
                    style={{ width: 24, height: 24 }}
                  />
                  <Typography fontWeight="bold">Messenger</Typography>
                </Box>
              </a>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default InforPage;